import React from 'react';
import { createRoot } from 'react-dom/client';
import CookieManager from '../cookie-manager';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('cookie-manager-root');

  const props = JSON.parse(root.dataset.props);

  createRoot(root).render(<CookieManager {...props} />);
});
